/* eslint-disable indent */
import Element from 'zk-ui';
import ZKElementUI from '@zk/element-ui';
import ZkFrameworkVue from '@zk/framework-vue';
import * as ZkEditor from 'zk-editor';
import * as ZkDatePicker from 'zk-date-picker';

window.ZkElementUI = ZKElementUI;
window.ZkFrameworkVue = ZkFrameworkVue;
window.ELEMENT = Element;
window.ZkEditor = ZkEditor;
                 
ZkDatePicker.config({ locale: 'en-US' });
         
window.ZkDatePicker = ZkDatePicker;
window['vue-virtual-scroller'] = require('vue-virtual-scroller');
window.ClipboardJS = require('clipboard');
// 暴露给子应用 模拟CDN
                                            
                          
                      
                                   
                               
                        

                         
                     
                 
                             
                   
                       
                                         
                                
                                     
                                              
                                        
                                        
                                                           
                                     
                                
                                              
         
